import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "narrow-view" }
const _hoisted_2 = {
  key: 0,
  class: "busy-indicator-container"
}

import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import FormButton from '@/components/common/FormButton.vue'
import FormButtonGroup from '@/components/common/FormButtonGroup.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import PasswordResetForm from '@/components/forms/PasswordResetForm.vue'
import PasswordReset from '@/utils/password-reset'


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordResetView',
  setup(__props) {

const route = useRoute()

const homepageUrl: string =
  process.env.VUE_APP_HOMEPAGE_URL ?? 'https://keilailu.fi/'

/* local state */

const isLoading = ref<boolean>(false)
const isValidToken = ref<boolean>(true)

/* computed */

const token = computed<string>((): string => route.params.token as string)

/* actions */

const navigateToHomepage = (): string => (window.location.href = homepageUrl)

/* hooks */

onMounted(async () => {
  if (route.name !== 'password-reset-with-token') {
    return
  }

  isLoading.value = true

  isValidToken.value = await PasswordReset.verifyToken(token.value)

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [
          _createVNode(BusyIndicator)
        ]))
      : (!isValidToken.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(NotificationBanner, {
              message: _ctx.$t('password-reset.invalid-token-error'),
              "is-danger": ""
            }, null, 8, ["message"]),
            _createVNode(FormButtonGroup, null, {
              default: _withCtx(() => [
                _createVNode(RouterLinkButton, { to: { path: '/login' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('general.login')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(FormButton, { onClick: navigateToHomepage }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('general.to-homepage')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('password-reset.heading')), 1),
            _createVNode(PasswordResetForm, { token: token.value }, null, 8, ["token"])
          ], 64))
  ]))
}
}

})